import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { NxtPodcastEpisode } from "../models/nxt-podcast-episode.model";

@Injectable({
  providedIn: "root"
})
export class NxtPodcastService {
  constructor(private http: HttpClient) {}

  getEpisodes(limit: number = 10): Observable<NxtPodcastEpisode[]> {
    return this.http.get<NxtPodcastEpisode[]>(
      `${environment.apiURL}/nxt-podcast/episodes?limit=${limit}`
    );
  }
}
